(ns frontend.view.syncing-data
  (:require
   [reagent.core :as r]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.routing :as routing]))

(defn sync-content
  []
  [:div.spinner-wrapper 
   [:img
    {:src        "/img/new-spinner.gif"
     :class-name "img-responsive"}]
   
   [:div.spinner__title (loc/tr :spinner-title)]
   [:div.spinner__desc (loc/tr :spinner-desc)]])

(defn view
  []
  [:div.syncing-data
   [sync-content]])

(defn wait-until-sync-progress
  [progress-number child-view]
  (let [current-progress (or @session/sync-progress 0)]
    (if (< current-progress progress-number)
      [view]
      child-view)))

(defmethod routing/render-view :syncing-data
  [_]
  [view])
